module.exports = new __parcel__URL__("commit-details-popup.tpl.ef7b25c8.svg").toString();